const roleTypes = [
    { name: "Admin", value: "Admin" },
    { name: "General", value: "General" },
  ];

export {roleTypes}